import React, { forwardRef } from 'react';

// DEPENDENCIES
import { compose } from 'redux';

// HELPERS
import { virtualizedLoader } from '../../helpers/virtualizedLoader';

// LOCAL COMPONENTS
import ListCard from './ListCard';

const ListVirtualized = compose(
  virtualizedLoader,
  forwardRef
)(({ ...props }, ref) => {
  return <ListCard {...props} ref={ref} />;
});

// EXPORT
export default ListVirtualized;
